export default "__VITE_ASSET__zrU48H$9__"